export let PACKAGE_PICKER_EVENTS = /*#__PURE__*/function (PACKAGE_PICKER_EVENTS) {
  PACKAGE_PICKER_EVENTS["PAGE_LOAD_START"] = "PAGE_LOAD_START";
  PACKAGE_PICKER_EVENTS["PAGE_LOAD_FINISH"] = "PAGE_LOAD_FINISH";
  PACKAGE_PICKER_EVENTS["COMPONENT_LOAD_START"] = "COMPONENT_LOAD_START";
  PACKAGE_PICKER_EVENTS["COMPONENT_LOAD_FINISH"] = "COMPONENT_LOAD_FINISH";
  PACKAGE_PICKER_EVENTS["CLICK_ON_SELECT_PLAN"] = "CLICK_ON_SELECT_PLAN";
  PACKAGE_PICKER_EVENTS["CLICK_ON_COMPARE_PLAN_FEATURES"] = "CLICK_ON_COMPARE_PLAN_FEATURES";
  PACKAGE_PICKER_EVENTS["HOVER_ON_FEATURE_TOOLTIP"] = "HOVER_ON_FEATURE_TOOLTIP";
  PACKAGE_PICKER_EVENTS["CLICK_ON_FEATURE_TOOLTIP_LINK"] = "CLICK_ON_FEATURE_TOOLTIP_LINK";
  PACKAGE_PICKER_EVENTS["TOGGLE_SHOW_MORE_FEATURES"] = "TOGGLE_SHOW_MORE_FEATURES";
  PACKAGE_PICKER_EVENTS["TOGGLE_FEATURE_SECTION"] = "TOGGLE_FEATURE_SECTION";
  return PACKAGE_PICKER_EVENTS;
}({});
//# sourceMappingURL=events.js.map